import { Flex, Image } from '@chakra-ui/react';
import { cartridges } from '../../cartridges';

interface ICartridge {
	type: number;
	current: number;
}

enum EType {
	Active,
	Inactive,
}

/**
 * @dev 'translateX' props set at the maximum inner node not to interfere
 *  with the carousel animations
 * @param type
 * @param current
 * @constructor
 */
export const Cartridge = ({ type, current }: ICartridge) => {
	const isActive = type === current;

	/**
	 * @param base units to offset by
	 */
	const getOffset = (base: number = 166) => {
		if (isActive) {
			return 0;
		}

		if (current === 0) {
			switch (type) {
				case 1:
					return base;
				case 2:
					return 2*base;
			}
		}

		if (current === 1) {
			switch (type) {
				case 0:
					return -base;
				case 2:
					return base;
			}
		}

		if (current === 2) {
			switch (type) {
				case 0:
					return 2 * -base;
				case 1:
					return -base;
			}
		}
	};

	const typeStyles = {
		[EType.Active]: {} as const,
		[EType.Inactive]: {
			opacity: '.25',
			transform: `scale(.66) translateX(${getOffset()}%)`,
		} as const,
	};

	return (
		<Flex
			justify="center"
			align="center"
			position="absolute"
			height="338px"
			width="600px"
			transition="all 1s cubic-bezier(0.42, 0, 0, 1)"
			{...typeStyles[isActive ? EType.Active : EType.Inactive]}
		>
			<Image
				src={'/assets/brand/cartridges/' + cartridges[type].image}
				margin="30px 100px 0px"
				zIndex="1"
				height="338px"
				width="600px"
			/>
			<Image
				position="absolute"
				src={'/assets/brand/cartridges/' + cartridges[type].image}
				filter="blur(50px)"
				zIndex="0"
				height="338px"
				width="600px"
			/>
		</Flex>
	);
};
